import type { ProLayoutProps } from "@ant-design/pro-components";

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: "light",
  colorPrimary: "#009040",
  layout: "mix",
  title:'车辆垃圾清运台账管理系统',
  contentWidth: "Fluid",
  fixedHeader: false,
  fixSiderbar: true,
  siderWidth: 200,
  pwa: true,
  logo: "/logo.png",
  token: {},
  splitMenus: false,
  siderMenuType: "sub",
  footerRender: false,
  collapsed:false,
   Amap:{
      name:'高德地图',
      amapKey:'73ec69fa38f263740b39c16c4fb56338',
      amapSecretKey:'40e82e982692f67b6b23a0d59cda7f4b'
    },
};

export default Settings;
